export const MapBoxStreetStyle: string = 'mapbox://styles/mapbox/streets-v11';
export const MapBoxSatelliteStyle: string = 'mapbox://styles/mapbox/satellite-v9';
export const MapBoxSatelliteStreetsStyle: string = 'mapbox://styles/mapbox/satellite-streets-v11';
export const MapBoxOutdoorsStyle: string = 'mapbox://styles/mapbox/outdoors-v11';

export const mapStyles = {
  satellite: 'satellite-streets-v11',
  street: 'streets-v11',
  topographic: 'outdoors-v11',
};


export const getMapStyles = () => {
  return {
    satellite: 'satellite-streets-v11',
    topographic: 'outdoors-v11',
  };
};
